import type { Href } from "expo-router";

/** The subtree every Patriot tools page lives under, below the tenant. */
export const PATRIOT_TOOLS_SEGMENT = "patriot-tools";

export function patriotToolsHref(tenantId: string, subpath = "", query: Record<string, string | undefined> = {}): Href {
  const params = new URLSearchParams();
  for (const [key, value] of Object.entries(query)) {
    if (value !== undefined && value !== "") params.set(key, value);
  }
  const search = params.toString();
  const path = `/tenants/${tenantId}/${PATRIOT_TOOLS_SEGMENT}${subpath ? `/${subpath}` : ""}`;
  // Typed routes cannot see a path assembled at runtime.
  return (search ? `${path}?${search}` : path) as Href;
}

export interface PatriotTool {
  readonly subpath: string;
  readonly title: string;
  readonly description: string;
}

/** The pages listed on the Patriot tools landing page. Add a page here to list it. */
export const PATRIOT_TOOLS: readonly PatriotTool[] = [
  {
    subpath: "tenant-activations",
    title: "Tenant activations",
    description: "Patriot activations for this tenant",
  },
  {
    subpath: "tenant-signals",
    title: "Tenant signals",
    description: "Patriot signals for this tenant",
  },
  {
    subpath: "fleet-activations",
    title: "Fleet activations",
    description: "Patriot activations across the whole fleet",
  },
];
